import React from 'react';

import { SVGComponentProps } from './svg.types';

const DesignnCreativeSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.334 10.4961L11.3725 6.86143C11.5242 6.33039 12.0777 6.0229 12.6087 6.17462C12.9409 6.26954 13.2006 6.52922 13.2955 6.86143L14.334 10.4961V11.9961H15.0532C15.5121 11.9961 15.9121 12.3084 16.0234 12.7535L17.385 18.2002C19.1847 16.7333 20.334 14.4989 20.334 11.9961C20.334 7.57781 16.7523 3.99609 12.334 3.99609C7.9157 3.99609 4.33398 7.57781 4.33398 11.9961C4.33398 14.4989 5.4833 16.7333 7.28295 18.2002L8.64461 12.7535C8.75591 12.3084 9.15589 11.9961 9.61476 11.9961H10.334V10.4961ZM12.334 19.9961C12.5755 19.9961 12.8153 19.9854 13.0529 19.9643C13.9527 19.8841 14.8096 19.655 15.5989 19.3017L14.2724 13.9961H10.3956L9.06912 19.3017C9.85836 19.655 10.7153 19.8841 11.6151 19.9642C11.8527 19.9854 12.0925 19.9961 12.334 19.9961ZM12.334 21.9961C6.81113 21.9961 2.33398 17.5189 2.33398 11.9961C2.33398 6.47324 6.81113 1.99609 12.334 1.99609C17.8568 1.99609 22.334 6.47324 22.334 11.9961C22.334 17.5189 17.8568 21.9961 12.334 21.9961Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default DesignnCreativeSVG;
